module.exports = __webpack_public_path__ + "static/AviaryAttorney0-794b6b965af1bf511336f153aa53a73a.png";